import { useEffect, useState } from 'react';
import { Select, message, Spin } from 'antd';
import axios from 'axios';
import { BaseUrl } from '../../Constants/Constants';

const { Option } = Select;

const CourseFilterDropdown = ({ value, onChange, placeholder = "Select Course" }) => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadCourses = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BaseUrl}courses/findAll`, { withCredentials: true });
        setCourses(response.data.data || []);
      } catch (error) {
        console.error('Error loading courses:', error);
        message.error('Failed to load courses.');
      } finally {
        setLoading(false);
      }
    };
    loadCourses();
  }, []);

  // Handle selection - pass both id and title to parent
  const handleChange = (courseId) => {
    const selectedCourse = courses.find(c => c.course_id === courseId);
    if (selectedCourse && onChange) {
      onChange({
        course_id: selectedCourse.course_id,
        course_name: selectedCourse.course_title
      });
    } else if (!courseId && onChange) {
      onChange(null); // Handle clear
    }
  };

  return (
    <Spin spinning={loading}>
      <Select
        placeholder={placeholder}
        allowClear
        showSearch
        style={{ width: '100%' }}
        value={value?.course_id || value} // Support both object and string
        onChange={handleChange}
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
        }
      >
        {courses.map(course => (
          <Option key={course.course_id} value={course.course_id}>
            {course.course_title}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default CourseFilterDropdown;